<template>
	<!-- Componente wrapper -->
  <v-container grid-list-md class="px-0 py-2">
    <v-layout wrap>
      <v-flex xs12 v-if="form_enviado" class="text-center pt-5 pb-5">
        <v-card class="px-5 py-3 mx-auto" max-width="600" color="#e0f7e9" elevation="2">
          <v-card-title class="justify-center">
            <v-icon large color="green darken-2">mdi-check-circle</v-icon>
          </v-card-title>
          <v-card-text>
            <h2 class="green--text text--darken-2 font-weight-bold">Formulário enviado com sucesso!</h2>
            <p class="mt-3">Agradecemos pelo envio. Seus dados foram registrados corretamente.</p>
          </v-card-text>
          <v-card-actions class="justify-center mt-4">
            <v-btn class="btn-return" depressed dark round @click="reenviarFormulario">
              <v-icon small class="mr-2">
                fas fa-return
              </v-icon>
              Enviar novo formulário
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 elevation="2" v-if="!form_enviado && (!eh_form_valido || !Object.keys(item.modelo.campos || {}).length)">
        <div class="card-form info-indisponivel">
          Oops! No momento, este formulário não está disponível! :(
          <br />
          Contacte o administrador do site!
        </div>
      </v-flex>
      <v-flex xs12 elevation="2" v-if="!form_enviado && eh_form_valido && Object.keys(item.modelo.campos || {}).length" class="card-form pt-3 pb-4 px-3">
        <v-flex xs12 style="text-align: center;">
          <h2 v-if="item.titulo">{{ item.titulo }}</h2>

          <h4 v-if="item.subtitulo">{{ item.subtitulo }}</h4>
        </v-flex>

        <v-flex xs12>
          <v-divider class="my-3" />
        </v-flex>
        <v-flex v-for="(campo, index) in item.modelo.campos" :key="index" xs12>
          <span v-if="ehData(campo.identificacao)">
            <v-text-field
              v-model="campo.valor"
              mask="##/##/#### ##:##:##"
              box
              hide-details
              :label="campo.identificacao"
              placeholder="dd/mm/aaaa hh:mm:ss"
              clearable>
            </v-text-field>
          </span>
          <span v-else>
            <v-text-field
              v-if="campo.tipo === 1"
              v-model="campo.valor"
              v-coco-mask="getCampoMaskText(campo)"
              v-validate="{ required: campo.required === undefined ? false : campo.required }"
              :data-vv-name="campo.identificacao"
              :error-messages="errors.collect(campo.identificacao)"
              :label="campo.required === true ? campo.identificacao+'*' : campo.identificacao"
              box
              hide-details />
          </span>
          <v-flex v-if="campo.tipo === 'uf'">
            <v-autocomplete
              v-model="campo.valor"
              :items="ufs"
              outlined
              box
              hide-details
              deletable-chips
              :label="campo.required === true ? campo.identificacao + '*' : campo.identificacao"
              clearable
              no-data-text="Nenhuma UF cadastrada"
              @click:clear="campo.valor = null"
              :menu-props="{ offsetY: true, maxHeight: 300 }"
              attach
            />
          </v-flex>
          <v-flex v-if="campo.tipo === 'orgao_rg'">
            <v-autocomplete
              v-model="campo.valor"
              :items="organizacoes"
              outlined
              box
              hide-details
              deletable-chips
              :label="campo.required === true ? campo.identificacao + '*' : campo.identificacao"
              clearable
              no-data-text="Nenhum órgão cadastrado"
              @click:clear="campo.valor = null"
              :menu-props="{ offsetY: true, maxHeight: 300 }"
              attach
            />
          </v-flex>
          <v-textarea
            v-if="campo.tipo === 2"
            v-model="campo.valor"
            v-validate="{ required: campo.required === undefined ? false : campo.required }"
            :data-vv-name="campo.identificacao"
            :error-messages="errors.collect(campo.identificacao)"
            :label="campo.required === true ? campo.identificacao+'*' : campo.identificacao"
            box
            hide-details />
          <v-text-field
            v-if="campo.tipo === 3"
            v-model="campo.valor"
            v-validate="{ required: campo.required === undefined ? false : campo.required }"
            :data-vv-name="campo.identificacao"
            :error-messages="errors.collect(campo.identificacao)"
            :label="campo.required === true ? campo.identificacao+'*' : campo.identificacao"
            type="number"
            min="0"
            box
            hide-details />
          <template v-if="campo.tipo === 4 || campo.tipo === 'modelo_contratacao'">
            <h4 class="mt-3">
              {{ campo.required === true ? campo.identificacao+'*' : campo.identificacao }}
            </h4>
            <v-radio-group v-model="campo.valor"
              v-validate="{ required: campo.required === undefined ? false : campo.required }"
              :data-vv-name="campo.identificacao"
              :error-messages="errors.collect(campo.identificacao)"
              row class="ma-0" hide-details>
              <v-radio
                v-for="(opcao, i) in (campo.tipo === 'modelo_contratacao' ? $functions.items_modelo_contratacao(true) : campo.opcoes)"
                :key="i"
                :value="(campo.tipo === 'modelo_contratacao' || campo.identificacao === 'Status de atendimento')
                  ? opcao.valor : opcao.nome"
                :label="opcao.nome" />
            </v-radio-group>
          </template>

          <template v-if="campo.tipo ===6">
            <h3 id="titulo" class="title font-weight">
              {{ campo.identificacao }}
            </h3>
            <span />
            <h3 id="subtitulo" class="subtitle-1 font-weight">
              {{ campo.subtitulo }}
            </h3>
          </template>

          <template v-if="campo.tipo === 5">
            <h4 class="mt-3">
              {{ campo.identificacao }}
            </h4>
            <v-layout wrap>
              <v-flex v-for="(opcao, i) in campo.opcoes" :key="i" style="max-width: max-content">
                <v-checkbox
                  v-model="opcao.valor"
                  :label="opcao.nome"
                  class="ma-0 pr-2"
                  hide-details />
              </v-flex>
            </v-layout>
          </template>
          <template v-if="campo.tipo === 7">
            <h3 class="mt-3">
              {{ campo.identificacao }}
            </h3>
						<div class="fotos_inserir">
							<img v-show="imagens_visualizacao[index]" :src="imagens_visualizacao[index]" class="round-7"> <input :ref="`input${index}`" class="fileInput" type="file" accept="image/*"
								@change="uploadFile($event, index)">
							<div>
								<div v-if="!imagePreviews[index] && !campo.valor">
									<v-btn small type="button" class="primary" style="background-color: #4399ff !important; color: #fff !important; margin-left: 0px;" @click="openDialog(index)">
										Adicionar imagem
									</v-btn>
								</div>
								<div v-else>
									<v-btn small type="button" class="warning" style="background-color: #ff9800 !important; color: #000 !important; margin-left: 0px;" @click="removerImagem(index)">
										Remover imagem
									</v-btn>
								</div>
							</div>
						</div>
          </template>
          <template v-if="campo.tipo === 8">
            <div class="imagemInformativa">
              <h3 class="mt-3">
                {{ campo.identificacao }}
              </h3>
              <div class="fotos">
                <img
                  :src="campo.valor"
                  aspect-ratio="1"
                  class="miniaturas grey lighten-2 round-7 pointer"
                  @click="abrirFotos(campo.valor)">
              </div>
            </div>
          </template>
        </v-flex>
        <div class="mt-3" style="display: flex; justify-content: center;">
          <Hcaptcha
            ref="hcaptcha"
            :site-key="key_captcha"
            @verified="onCaptchaVerified"
            @expired="onCaptchaExpired"
            @error="onCaptchaError"
          />
        </div>
        <div style="display: flex; justify-content: center;">
          <v-btn depressed round class="mt-4 btn-send" @click="uploadImage()">
            <span>Enviar</span>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
	<!-- Fim componente wrapper -->
</template>

<script>
import ufs from '@Consts/estados';
import { organizacoes } from '@Consts/conselhos';
import moment from 'moment';
import crud from '@Mixins/crud';
import formularioDados from '@Mixins/formularioDados';
import FormularioLinkPresenter from '@Presenter/formulario-link-presenter';
import FormularioPresenter from '@Presenter/formulario-presenter';
import Hcaptcha from '@Componentes/captcha.vue';

export default {
  name: 'DialogFormularioPagina',
  $_veeValidate: { validator: 'new' },
  components: { Hcaptcha },
  mixins: [crud, formularioDados],
  props: {
  },
  data: () => ({
    ufs,
    organizacoes,
    visita: null,
    imagePreviews: {},
    imagePreview: {},
    indexCampoImagens: [],
    indexCampo: [],
    imageData: '',
    gatilho: false,
    hasImage: true,
    not_image: false,
    images: [],
    presenter: 'formulario',
    profissionais: [],
    carregando_profissionais: false,
    carregando_data: false,
    carregando_configuracoes: false,
    permissao: {},
    item: {
      titulo: null,
      subtitulo: null,
      profissional_id: null,
      campos: {},
      data_hora: moment().format('DD/MM/YYYY HH:mm'),
      visualizacao: false
    },
    visualizacoes: [
      {
        text: 'Liberado',
        value: 'liberado'
      },
      {
        text: 'Bloqueado',
        value: 'bloqueado'
      }
    ],
    visualizacao: 'bloqueado',
    modelos: [],
    carregando_modelos: false,
    dialog_aviso_editar_visita: false,
    form_enviado: false,
    campos_enviar: {},
    captchaToken: null,
  }),
  computed: {
    btn_submit_disabled() {
      const { profissional_id, titulo } = this.item;
      const { id } = this.item.modelo;
      return this.eh_novo ? !profissional_id || !titulo || !id : false;
    },
    imagens_visualizacao() {
      if (this.gatilho)
        return this.imagePreview;
      return this.imagePreview;
    },
    eh_form_valido() {
      if (!(this.item || {}).data_validade) return true;
      return new Date() <=  new Date(this.item.data_validade);

    }
  },

  watch: {
    'item.profissional_id': {
      handler(value) {
        if (value) {
          if (this.permissao.visualizacao === 'liberado') this.visualizacao = 'liberado';
          else if (this.permissao.visualizacao === 'bloqueado') this.visualizacao = 'bloqueado';
          else {
            const profissional = this.profissionais.find(element => element.id === value);
            if (this.item.configuracoes && this.item.configuracoes.visualizacao)
              this.visualizacao = this.item.configuracoes.visualizacao;
            else if (profissional.especialidades.length && profissional.especialidades.filter(especialidade => !!especialidade.configuracoes).length)
              this.visualizacao = profissional.especialidades.some(especialidade => (especialidade.configuracoes || {}).visualizacao === 'bloqueado') ? 'bloqueado' : 'liberado';
            else this.visualizacao = 'bloqueado';
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.fetchFormularioPorToken();
  },
  methods: {
    onCaptchaVerified(token) {
      this.captchaToken = token;
      this.uploadImage();
    },
    onCaptchaExpired() {
      this.captchaToken = null;
      this.$store.dispatch('SHOW_SNACKBAR', {
        color: 'warning',
        message: 'Captcha expirado.'
      });
    },
    onCaptchaError() {
      this.$store.dispatch('SHOW_SNACKBAR', {
        color: 'error',
        message: 'Erro ao carregar o captcha.'
      });
    },
    ehData(ident) {
      if (((ident || '').toLowerCase()).includes('data ')) return true;
      return false;
    },
    getCampoMaskText(campo) {
      if (!(campo || {}).identificacao || !(campo || {}).valor) return null;
      const identificacao = campo.identificacao.toLowerCase();

      switch (true) {
        case identificacao.includes('cpf'):
        case identificacao.includes('cnpj'):
          return ['###.###.###-##', '##.###.###/####-##'];
        case identificacao.includes('número do telefone'):
        case identificacao.includes('telefone do'):
          return ['(##) ####-####', '(##) #####-####'];
        case identificacao.includes('cep'):
          return ['#####-###'];
        default:
          return null;
      }
    },
    resetInfos() {
      this.captchaToken = null;
      this.campos_enviar = [];
      this.images = [];
      this.imagePreviews = {};
      this.imagePreview = {};
      this.indexCampoImagens = [];
      this.indexCampo = [];
      this.gatilho = false;
    },
    async fetchFormularioPorToken() {
      this.carregando = true;
      this.resetInfos();
      let data = null;
      await FormularioLinkPresenter.renderizarPaginaPublica(this.$route.params.link_token, {})
      .then((response) => {
        data = response;
        this.item = {
          ...data,
          campos: data.modelo ? (Array.isArray(data.modelo.campos)
            ? data.modelo.campos
            : JSON.parse(data.modelo.campos || '[]')) : Array.isArray(data.modelo_padrao.campos)
            ? data.modelo_padrao.campos
            : JSON.parse(data.modelo_padrao.campos || '[]'),
          data_hora: moment().format('DD/MM/YYYY HH:mm'),
          visualizacao: false,
        };
      })
      .catch((err) => {
        console.error('Erro ao carregar formulário:', err);
      })
      .finally(() => {
        this.carregando = false;
      });
    },
    salvo(item) {
      this.form_enviado = true;
    },
    reenviarFormulario() {
      this.form_enviado = false;
      this.fetchFormularioPorToken();
    },
    removerImagem(index) {
      this.imagePreviews[index] = null;
      this.item.modelo.campos[index].valor = null;
      this.imagePreview[index] = null;
      this.gatilho = false;
    },
    openDialog(index) {
      const input = this.$refs[`input${index}`][0];
      input.click();
    },
    uploadFile(e, index) {
      const file = e.target.files && e.target.files.length ? e.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = event => {
          this.item.modelo.campos[index].valor = event.target.result;
          this.imagePreview[index] = event.target.result;
          this.gatilho = true;
          this.imagePreviews[index] = file;
        };

        reader.readAsDataURL(file);
      }
    },
    getPosicao(index) {
      this.indexCampo.push(index);
    },
    async afterFetch() {
      if ((this.item.modelo || {}).campos) {
        if (typeof this.item.modelo.campos === 'string') this.items.campos = JSON.stringify(this.item.modelo.campos);
        if (this.item.modelo.campos.length)
          this.item.modelo.campos.forEach((campo, index) => {
            if (campo.tipo === 7)
              this.imagePreview[index] = campo.valor;
          });
      }
      if ((this.item.links || []).length && this.item.links[0].personalizacao) {
        if (typeof this.item.links[0].personalizacao === 'string') this.items.personalizacao = JSON.stringify(this.item.links[0].personalizacao);
      }
      if (this.item.data_hora) {
        const parsedDate = moment(this.item.data_hora, 'YYYYMMDDHHmm');
        if (parsedDate.isValid())
          this.item.data_hora = parsedDate.format('DD/MM/YYYY HH:mm');
      }
    },
    addPath(paths) {
      this.indexCampoImagens.forEach((item, index) => {
        this.item.modelo.campos[item].valor = paths.urls[index];
      });
    },
    buildValor(campo) {
      if (campo.tipo !== 5) return campo.valor;
      return campo.opcoes.filter(op => op.valor).map(op => op.nome);
    },
    config_visualizacao(especialidade) {
      if (especialidade.length)
        this.visualizacao = especialidade[0].visualizacao;
    },
    fechaModal() {
      this.$emit('close', true);
    },
    validarCampos() {
      let temErro = null;
      let valor = null;
      let identificacao = null;
      const modelo_campos = this.$lodash.cloneDeep(this.item.modelo.campos);
      this.campos_enviar = modelo_campos.map(campo => {
        valor = this.buildValor(campo);
        identificacao = (campo.identificacao || '').toLowerCase();

        if (valor && typeof valor === 'string') {
          if (identificacao.includes('cpf') || identificacao.includes('cnpj')) {
            if (!this.$functions.validarCpfCnpj(valor.trim())) {
              temErro = `Campo ${campo.identificacao} está inválido: ${valor}`;
            }
            return campo;
          }

          if (identificacao === 'uf' || identificacao.startsWith('uf ')) {
            if (!this.$functions.validarUf(valor.trim())) {
              temErro = `Campo ${campo.identificacao} possui UF brasileira inválida: ${valor}`;
            }
            return campo;
          }

          if (identificacao.includes('email')) {
            if (!this.$functions.validarEmail(valor.trim())) {
              temErro = `Campo ${campo.identificacao} possui e-mail inválido: ${valor}`;
            }
            return campo;
          }

          if (identificacao.includes('data ')) {
            valor = valor.trim();
            const formatosAceitos = ['DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss'];

            // Corrigir valor com 8 dígitos (data pura)
            if (/^\d{8}$/.test(valor)) {
              valor = `${valor.substring(0, 2)}/${valor.substring(2, 4)}/${valor.substring(4, 8)}`;
            }

            // Corrigir valor com 14 dígitos (data e hora)
            else if (/^\d{14}$/.test(valor)) {
              valor = `${valor.substring(0, 2)}/${valor.substring(2, 4)}/${valor.substring(4, 8)} ` +
                      `${valor.substring(8, 10)}:${valor.substring(10, 12)}:${valor.substring(12, 14)}`;
            }

            // Se não for um formato reconhecido, rejeita antes de tentar o moment
            else if (!/^\d{2}\/\d{2}\/\d{4}( \d{2}:\d{2}:\d{2})?$/.test(valor)) {
              temErro = `Campo ${campo.identificacao} possui data inválida: ${valor}`;
              return;
            }

            const momentObj = moment(valor, formatosAceitos, true);
            if (momentObj.isValid()) {
              const ano = momentObj.year();
              if (ano < 1900 || ano > moment().year()) {
                temErro = `Campo ${campo.identificacao} possui ano inválido (${ano})`;
                return campo;
              }
              campo.valor = this.$functions.formatDateToRequest(valor);
            } else {
              temErro = `Campo ${campo.identificacao} possui data inválida`;
            }
          }
        }
        return campo;
      });

      if (temErro) {
        this.$store.dispatch('SHOW_SNACKBAR', { color: 'error', message: temErro });
        return false;
      }

      return true;
    },
    uploadImage() {
      const isValid = this.validarCampos();
      if (!isValid) {
        return;
      }

      if (!this.captchaToken) {
        this.$refs.hcaptcha.execute();
        return;
      }

      this.carregando_data = true;
      const formData = new FormData();
      if (Object.keys(this.imagePreviews).length) {
        Object.keys(this.imagePreviews).forEach(key => {
          this.indexCampoImagens.push(key);
          formData.append(`image`, this.imagePreviews[key]);
        });
        FormularioPresenter.uploadImage(formData)
          .then(response => {
            this.addPath(response);
            this.submeter();
          })
          .finally(() => {
            this.carregando_data = false;
          });
      } else
        this.submeter();
    },
    async finalizar() {
      this.carregando_data = true;
      const formData = new FormData();
      if (Object.keys(this.imagePreviews).length) {
        Object.keys(this.imagePreviews).forEach(key => {
          this.indexCampoImagens.push(key);
          formData.append('image', this.imagePreviews[key]);
        });
        FormularioPresenter.uploadImage(formData)
          .then(response => {
            this.addPath(response);
            this.submeter();
          })
          .finally(() => {
            this.carregando_data = false;
          });
      } else
        this.submeter();
    },
    uploadFoto(output) {
      this.not_image = false;
      if (output.info) {
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(output.info.type)) this.not_image = true;
      } else if (!['image/png', 'image/jpg', 'image/jpeg'].includes(output.type)) this.not_image = true;
      else this.not_image = false;
      if (!this.not_image) {
        this.hasImage = true;
        this.images.push(output && output.dataUrl);
      }
    },
    customValidation() {
      return new Promise(resolve => {
        const data_hora = moment(this.item.data_hora, 'DD/MM/YYYY HH:mm');
        if ((this.visita || {}).entrada)
          if (data_hora.isBefore(moment(this.visita.entrada)))
            return resolve({
              message:
                'Data e hora não podem ser anteriores ao início da visita',
              bool: false
            });

        if (this.item.data_hora)
          if (!data_hora.isValid())
            return resolve({ message: 'Data inválida', bool: false });
        return resolve({ bool: true });
      });
    },
    async getUserIp() {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const { ip } = await response.json();
        return ip;
      } catch (err) {
        console.error('Erro ao obter IP:', err);
        return null;
      }
    },
    getDeviceInfo() {
      const { userAgent } = navigator;
      return userAgent;
    },
    async createData() {
      const ip = await this.getUserIp();
      const device = this.getDeviceInfo();

      const campos = this.item.modelo.campos.map(campo => ({
        ...campo,
        valor: this.buildValor(campo)
      }));
      const campos_enviar = this.campos_enviar.map(campo => ({
        ...campo,
        valor: this.buildValor(campo)
      }));
      const data = {
        lead: (this.item.modelo.tabela || '') === 'leads' ? this.createDataLead(campos_enviar) : null,
        profissional: (this.item.modelo.tabela || '') === 'profissionais' ? this.createDataProfissional(true, campos_enviar) : null,
        campos,
        titulo: this.item.titulo,
        subtitulo: this.item.subtitulo,
        paciente_id: (this.paciente || {}).id || null,
        profissional_id: this.item.profissional_id || null,
        visualizacao: this.item.visualizacao,
        configuracoes: {
          visualizacao: this.visualizacao
        },
        formulario_link_id: this.item.id,
        ip,
        device,
        empresa: this.item.instituicao_id,
      };

      if (this.item.data_hora)
        data.data_hora = moment(this.item.data_hora, 'DD/MM/YYYY HH:mm').format(
          'YYYY-MM-DD HH:mm'
        );
      if (this.item.modelo.tipo) {
        data.modelo_padrao_id = this.item.modelo.id;
        data.padrao = 1;
        data.tipo = this.item.modelo.tipo;
      } else
        data.modelo_id = this.item.modelo.id;
      return data;
    },
  }
};
</script>

<style scoped lang='scss'>
@import "@Assets/css/settings.scss";
.card-form {
  background-color: #eaeaea;
  color: #575757;
  border-radius: 5px;
  margin: 40px 0;

  .btn-send {
    margin-top: 30px !important;
    color: #fff !important;
    background-color: #13ce66 !important;
    padding: 10px 5% 10px 5%;
    min-width: 100px;
    max-width: 550px;
  }
}

.info-indisponivel {
  text-align: center;
  padding: 80px 20px;
}

.fileInput {
  display: none;
}
#titulo {
  padding-top: 20px;
  padding-bottom: 15px;
}
#subtitulo {
  padding-bottom: 15px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 10px;
}
.image-upload {
    position: relative;
    border: 1px solid #c1c1c1;
    border-radius: 5px;
    margin-bottom: 15px;
}
.img-preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
}
.imagemInformativa{
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.fotos_inserir{
  width: auto;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  img {
    display: inline-block;
    background-size: cover;
    width: 200px;
    height: 140px;
    margin: 6px;
    &:first-child {
      margin-left: 0;
    }
  }
}

.fotos {
  width: 400px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

  .miniaturas {
    background-size: cover;
    max-width:350px;
    max-height:200px;
    width: auto;
    height: auto;
    margin: 6px;

    &:first-child {
      margin-left: 0;
    }
  }

  img {
    display: inline-block;
    background-size: cover;
    width: 200px;
    height: 140px;
    margin: 6px;

    &:first-child {
      margin-left: 0;
    }
  }

  .round-7 {
    border-radius: 7px;
  }

  .titulo {
    font-size: 20px;
  }
}
</style>
